import Web3StatusService from './Web3StatusService';
import AsyncCoinContractABI from '../../build/contracts/AsyncCoin';
import { SET_ADDRESS } from '../storage/AccountReducer';
import { ASYNC_NETWORK_ID } from './Constants';

export const NO_ACCOUNT_FOUND = 'NO_ACCOUNT_FOUND';

export default class AsyncCoinContractService {
  init () {
    return Web3StatusService
      .then(results => {
        window.web3Service = results.web3;
        window.oldWeb3Service = results.oldWeb3;

        return this.fetchCurrentAccount()
          .then(() => this.instantiateContract());
      })
      .catch((err) => {
        return new Promise((resolve, reject) => {
          reject(err);
        });
      });
  }

  instantiateContract () {
    return new Promise((resolve, reject) => {

      // Initiate web3.js v1.0.0 contract
      const contractAddress = AsyncCoinContractABI.networks[ASYNC_NETWORK_ID].address;
      window.contract = new window.web3Service.eth.Contract(AsyncCoinContractABI.abi, contractAddress);

      let OldContract = window.oldWeb3Service.eth.contract(AsyncCoinContractABI.abi);
      window.oldWeb3Contract = OldContract.at(contractAddress);

      resolve();
    });
  }

  fetchCurrentAccount () {
    return new Promise((resolve, reject) => {
      window.web3Service.eth.getAccounts((error, accounts) => {
        if (error) {
          reject(error);
        }

        if (accounts.length === 0) {
          reject(NO_ACCOUNT_FOUND);
        }

        Storage.dispatch({type: SET_ADDRESS, payload: accounts[0]});
        resolve(accounts[0]);
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/AsyncCoinContractService.js